import dashboard from 'store/reducer'
import order from 'admin/reducers/orderReducer'
import accounts from 'partner/UserManagement/reducer'
import shield from 'components/Shield/store/reducer'

export default {
  dashboard,
  order,
  accounts,
  shield,
}
